import { render, staticRenderFns } from "./ManuscriptDeleteConfirm.vue?vue&type=template&id=b44a52cc&scoped=true"
import script from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts"
export * from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptDeleteConfirm.vue?vue&type=style&index=0&id=b44a52cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a52cc",
  null
  
)

export default component.exports